import { useCallback, useRef, useState, useEffect } from 'react';
import { Table } from '../components/table-pagination-sorting/components/Table';
import { PaginatingAndSortingProps } from '../components/table-pagination-sorting/interfaces/interfaces';
import { useDoneFetchActions } from '../hooks/useDoneFetchActions';
import useForm from '../hooks/useForm';
import { getPlantas } from '../services/adminServices';
import { litrosPorMeses } from '../services/reportesServices';
import { initialPlantas, propsPlantas } from '../utils/formsInitialsStates';

export const LitrosPorMeses = () => {

  const { handleInputChange, formValues } = useForm({
    fechaIni: '',
    meses: 1,
    planta: 0
  });
  const pages = useRef({} as PaginatingAndSortingProps)
  const [data, setData] = useState({ count: 0 } as { count: number, rows: Array<{ [key: string]: any }> });

  const doneFetchActions = useDoneFetchActions();

  const [plantas, setPlantas] = useState([initialPlantas])

  const updateTabla = useCallback((filtro: any) => {
    doneFetchActions(litrosPorMeses(filtro))
      .then(data => {
        setData({ rows: data, count: data.length });
      });
  }, [doneFetchActions])

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    updateTabla({ ...formValues, ...pages.current });
  };

  const handleChangeTable = (pageAction: PaginatingAndSortingProps) => {
    pages.current = pageAction;
    updateTabla({ ...formValues, ...pageAction });
  };

  useEffect(() => {
    doneFetchActions(getPlantas()).then((resp: [propsPlantas]) => {
      setPlantas(resp);
    })
  }, [doneFetchActions])

  function downCSV() {
    doneFetchActions(litrosPorMeses({ ...pages.current, ...formValues }, 'csv'))
  }

  const titles = [
    { name: "cedula", title: "Cédula" },
    { name: "nombre", title: "Nombre" },
    { name: "codigo", title: "Código" },
    ...(Object.keys(data.rows?.[0] || [])).filter(key => !["cedula", "nombre", "codigo"].includes(key)).map(name => ({ name, title: name }))
  ]

  return (
    <div>
      <div className='d-flex justify-content-center pt-4'>
        <h4 className="text-center mb-4">Reporte de litros por meses</h4>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <form onSubmit={handleSubmit} className="row g-3 align-items-center">
            <div className="col-lg-3">
              <div className="form-floating mb-3">
                <input
                  type="date"
                  id="fechaIni"
                  name="fechaIni"
                  value={formValues.fechaIni}
                  onChange={handleInputChange}
                  className="form-control form-control-lg"
                />
                <label htmlFor="fechaIni">Fecha inicial:</label>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="form-floating mb-3">
                <input
                  type="number"
                  id="meses"
                  name="meses"
                  value={formValues.meses}
                  onChange={handleInputChange}
                  className="form-control form-control-lg"
                />
                <label htmlFor="meses">Meses:</label>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="form-floating mb-3">
                <select
                  className="form-select form-select-lg"
                  id="planta"
                  name="planta"
                  value={formValues.planta}
                  onChange={handleInputChange}
                >
                  <option value={0} >Todas las plantas</option>
                  {plantas.map(p => <option key={`plata_${p.id}`} value={p.id}>{p.nombre}</option>)}
                </select>
                <label htmlFor="planta">Plantas:</label>
              </div>
            </div>
            <div className="col-lg-3 mt-0">
              <button type="submit" className="btn btn-lg btn-primary w-100 h-100">
                Filtrar
              </button>
            </div>
          </form>
        </div>
      </div>

      <Table dataTable={{ ...data, titles }} onChange={handleChangeTable} />
      <div className='d-flex justify-content-end'>
        <button onClick={downCSV} className='btn btn-secondary'>csv</button>
      </div>
    </div>
  );
};

